import _regeneratorRuntime from "/root/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(loadSaga),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(listenSaga),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(getTokenDetails),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(storeTokenDetails),
    _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(refreshToken),
    _marked6 =
/*#__PURE__*/
_regeneratorRuntime.mark(getToken),
    _marked7 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleAuthSuccess),
    _marked8 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleLogout),
    _marked9 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleSetActiveAccount);

import { call, put, select, takeLatest } from 'redux-saga/effects';
import storage from 'local-storage-fallback';
import { fetchDedupe } from 'fetch-dedupe';
import queryString from 'query-string';
import { sendCommand as sendServiceWorkerCommand } from '@signal/utils/serviceWorker';
import takeLeading from '@signal/utils/takeLeading';
import isTokenValid from './utils/isTokenValid';
import { authRequest, authSuccess, authFailure, logout, setActiveAccount } from './actions';
import { tokenSelector, isTokenValidSelector } from './selectors';
import { LOCAL_STORAGE_TOKEN_KEY, LOCAL_STORAGE_ACTIVE_ACCOUNT_KEY, CMD_CREATE_SESSION, CMD_DESTROY_SESSION } from './constants';
import { setRecentlyViewedAccount } from '../local/actions';
/**
 * Load saga for the auth loader. "Authenticates" the user by attempting to
 * retrieve his/her access token from local storage. If it doesn't exist, or
 * it has already expired, an attempt is made to request a token from the
 * authentication server. If that request fails, it's assumed that the user is
 * not authenticated and the `authFailure` action is dispatched; otherwise, the
 * `authSuccess` action is dispatched containing the freshly acquired token.
 */

export function loadSaga() {
  var tokenDetails;
  return _regeneratorRuntime.wrap(function loadSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(authRequest());

        case 2:
          _context.next = 4;
          return call(getTokenDetails);

        case 4:
          tokenDetails = _context.sent;

          if (isTokenValid(tokenDetails)) {
            _context.next = 13;
            break;
          }

          _context.next = 8;
          return call(refreshToken);

        case 8:
          tokenDetails = _context.sent;

          if (tokenDetails) {
            _context.next = 13;
            break;
          }

          _context.next = 12;
          return put(authFailure('Unable to authenticate'));

        case 12:
          return _context.abrupt("return");

        case 13:
          _context.next = 15;
          return put(authSuccess(tokenDetails));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export var getLogoutRedirectUrl = function getLogoutRedirectUrl() {
  return '/logout';
};
export var getAuthFailureRedirectUrl = function getAuthFailureRedirectUrl() {
  var _window$location = window.location,
      pathname = _window$location.pathname,
      search = _window$location.search;
  return "/login?".concat(queryString.stringify({
    redirect_url: "".concat(pathname).concat(search)
  }));
};
/**
 * Listener saga for the auth loader.
 */

export function listenSaga() {
  return _regeneratorRuntime.wrap(function listenSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(authSuccess, handleAuthSuccess);

        case 2:
          _context2.next = 4;
          return takeLatest(setActiveAccount, handleSetActiveAccount);

        case 4:
          _context2.next = 6;
          return takeLeading(logout, handleLogout, getLogoutRedirectUrl);

        case 6:
          _context2.next = 8;
          return takeLeading(authFailure, handleLogout, getAuthFailureRedirectUrl);

        case 8:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 * Retrieves the auth token from localStorage if it exists
 */

export function getTokenDetails() {
  var tokenDetails;
  return _regeneratorRuntime.wrap(function getTokenDetails$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return call([storage, storage.getItem], LOCAL_STORAGE_TOKEN_KEY);

        case 3:
          tokenDetails = _context3.sent;
          return _context3.abrupt("return", JSON.parse(tokenDetails));

        case 7:
          _context3.prev = 7;
          _context3.t0 = _context3["catch"](0);
          console.warn('Unable to parse stored token, requesting a fresh one.');

        case 10:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 7]]);
}
/**
 * Stores an auth token in localStorage
 */

export function storeTokenDetails(tokenDetails) {
  return _regeneratorRuntime.wrap(function storeTokenDetails$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return call([storage, storage.setItem], LOCAL_STORAGE_TOKEN_KEY, JSON.stringify(tokenDetails));

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
/**
 * Requests a new token from the auth server
 */

export function refreshToken() {
  var res, tokenDetails;
  return _regeneratorRuntime.wrap(function refreshToken$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return call(fetchDedupe, '/auth/token', {
            credentials: 'same-origin'
          });

        case 2:
          res = _context5.sent;

          if (res.ok) {
            _context5.next = 5;
            break;
          }

          return _context5.abrupt("return");

        case 5:
          tokenDetails = res.data;
          _context5.next = 8;
          return call(storeTokenDetails, tokenDetails);

        case 8:
          return _context5.abrupt("return", tokenDetails);

        case 9:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
/**
 * Returns the access token from state, refreshing it if necessary.
 */

export function getToken() {
  var isValid, tokenDetails, token;
  return _regeneratorRuntime.wrap(function getToken$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return select(isTokenValidSelector);

        case 2:
          isValid = _context6.sent;

          if (isValid) {
            _context6.next = 15;
            break;
          }

          _context6.next = 6;
          return put(authRequest());

        case 6:
          _context6.next = 8;
          return call(refreshToken);

        case 8:
          tokenDetails = _context6.sent;

          if (tokenDetails) {
            _context6.next = 13;
            break;
          }

          _context6.next = 12;
          return put(authFailure('Failed to refresh auth token'));

        case 12:
          return _context6.abrupt("return");

        case 13:
          _context6.next = 15;
          return put(authSuccess(tokenDetails));

        case 15:
          _context6.next = 17;
          return select(tokenSelector);

        case 17:
          token = _context6.sent;
          return _context6.abrupt("return", token);

        case 19:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
/**
 * ACTION HANDLER SAGAS
 */

/**
 * Messages the service worker to notify of an active auth session.
 */

export function handleAuthSuccess() {
  return _regeneratorRuntime.wrap(function handleAuthSuccess$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return call(sendServiceWorkerCommand, CMD_CREATE_SESSION);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}
/**
 * Destroys the user's session and redirects to the specified URL.
 * @param {String} getRedirectUrl - returns URL to redirect user to after their
 * session has been destroyed
 */

export function handleLogout(getRedirectUrl) {
  var redirectUrl;
  return _regeneratorRuntime.wrap(function handleLogout$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return call(sendServiceWorkerCommand, CMD_DESTROY_SESSION);

        case 2:
          _context8.next = 4;
          return call([storage, storage.removeItem], LOCAL_STORAGE_TOKEN_KEY);

        case 4:
          _context8.next = 6;
          return call([storage, storage.removeItem], LOCAL_STORAGE_ACTIVE_ACCOUNT_KEY);

        case 6:
          _context8.next = 8;
          return call(getRedirectUrl);

        case 8:
          redirectUrl = _context8.sent;
          window.location.assign(redirectUrl);

        case 10:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}
/**
 * Sets the active account in local storage so that it's persisted across sessions.
 * Dispatches setRecentlyViewAccount
 * @param {FluxStandardAction} action
 * @param {Object} action.payload - Active account details
 * @return {Generator}
 */

export function handleSetActiveAccount(_ref) {
  var activeAccount;
  return _regeneratorRuntime.wrap(function handleSetActiveAccount$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          activeAccount = _ref.payload;
          _context9.next = 3;
          return call([storage, storage.setItem], LOCAL_STORAGE_ACTIVE_ACCOUNT_KEY, JSON.stringify(activeAccount));

        case 3:
          _context9.next = 5;
          return put(setRecentlyViewedAccount(activeAccount));

        case 5:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}